/** TODO temporary. will be refactored */

import { CellNode, RowNode, Sort, SortOrder } from './experimental.grid';
import { PersonOfInterestModel } from './people-of-interest.user.model';
import { TranslationKeyMap } from './user.i18n';
import { User, UserHierarchy } from './user.model';

// defined as Active in api
// same as common.service.Status
export enum StatusType {
    BOTH = -1, // All
    INACTIVE, // No
    ACTIVE, // Yes
}

export interface UserSearchCriteria {
    scopeId?: number;
    userName?: string;
    managerName?: string;
    managerNameStatus?: StatusType;
    systemTypeId?: string;
    superGroupId?: number;
    superGroupStatus?: StatusType;
    roleId?: number;
    roleStatus?: StatusType;
    siteId?: number;
    siteStatus?: StatusType;
    areaId?: number;
    areaStatus?: StatusType;
    regionId?: number;
    regionStatus?: StatusType;
    lobId?: number;
    lobStatus?: StatusType;
    activeStatus?: StatusType;
    tenantId?: number;
    languageId?: number;
    effectiveUserId?: number;
    hierarchyTypeId?: number;
}

export interface UserSearchResult {
    userId: number;
    userName: string;
    siteId: number;
    site: string;
    roleId: number;
    role: string;
    managerId: number;
    managerName: string;
    superGroupId: number;
    superGroup: string;
    systemId: string;
    favourite: boolean;
    active: boolean;
}

export enum ParameterType {
    USER_NAME = 'userName',
    SUPER_GROUP_ID = 'superGroupId',
    SITE_ID = 'siteId',
    ROLE_ID = 'roleId',
    MANAGER_NAME = 'managerName',
    SYSTEM_TYPE_ID = 'systemTypeId',
    AREA_ID = 'areaId',
    REGION_ID = 'regionId',
    LOB_ID = 'lobId',
}

export enum InputType {
    TEXTBOX,
    DROPDOWN,
}

export interface ParameterTypeConfigItem {
    parameterType: ParameterType;
    label: string;
    hasStatus: boolean;
    inputType: InputType;
    placeholder?: string;
    statusLabel?: string;
}

export const StatusOpts: Array<{ value: StatusType; tlKey: string }> = [
    { value: StatusType.ACTIVE, tlKey: TranslationKeyMap._125_ACTIVE },
    { value: StatusType.INACTIVE, tlKey: TranslationKeyMap._7160_INACTIVE },
    { value: StatusType.BOTH, tlKey: TranslationKeyMap._7437_BOTH },
];

export const ParameterOpts: Array<{ value: ParameterType; tlKey: string }> = [
    { value: ParameterType.USER_NAME, tlKey: TranslationKeyMap._53_NAME },
    {
        value: ParameterType.SUPER_GROUP_ID,
        tlKey: TranslationKeyMap._67_SUPERGROUP,
    },
    { value: ParameterType.SITE_ID, tlKey: TranslationKeyMap._64_SITE },
    { value: ParameterType.ROLE_ID, tlKey: TranslationKeyMap._59_ROLE },
    {
        value: ParameterType.MANAGER_NAME,
        tlKey: TranslationKeyMap._50_MANAGER_NAME,
    },
    {
        value: ParameterType.SYSTEM_TYPE_ID,
        tlKey: TranslationKeyMap._85_SYSTEM_ID,
    },
    { value: ParameterType.AREA_ID, tlKey: TranslationKeyMap._148_AREA },
    { value: ParameterType.REGION_ID, tlKey: TranslationKeyMap._149_REGION },
    { value: ParameterType.LOB_ID, tlKey: TranslationKeyMap._583_LOB },
];

export const ParameterTypeConfig: { [key: string]: ParameterTypeConfigItem } = {
    [ParameterType.USER_NAME]: {
        parameterType: ParameterType.USER_NAME,
        label: TranslationKeyMap._53_NAME,
        hasStatus: false,
        inputType: InputType.TEXTBOX,
    },
    [ParameterType.SUPER_GROUP_ID]: {
        parameterType: ParameterType.SUPER_GROUP_ID,
        label: TranslationKeyMap._67_SUPERGROUP,
        hasStatus: true,
        inputType: InputType.DROPDOWN,
        placeholder: TranslationKeyMap._834_SELECT_A_SUPERGROUP,
    },
    [ParameterType.SITE_ID]: {
        parameterType: ParameterType.SITE_ID,
        label: TranslationKeyMap._64_SITE,
        hasStatus: true,
        inputType: InputType.DROPDOWN,
        placeholder: TranslationKeyMap._652_SELECT_A_SITE,
    },
    [ParameterType.ROLE_ID]: {
        parameterType: ParameterType.ROLE_ID,
        label: TranslationKeyMap._59_ROLE,
        hasStatus: true,
        inputType: InputType.DROPDOWN,
        placeholder: TranslationKeyMap._647_SELECT_A_ROLE,
    },
    [ParameterType.MANAGER_NAME]: {
        parameterType: ParameterType.MANAGER_NAME,
        label: TranslationKeyMap._50_MANAGER_NAME,
        hasStatus: true,
        inputType: InputType.TEXTBOX,
        statusLabel: TranslationKeyMap._48_MANAGER,
    },
    [ParameterType.SYSTEM_TYPE_ID]: {
        parameterType: ParameterType.SYSTEM_TYPE_ID,
        label: TranslationKeyMap._85_SYSTEM_ID,
        hasStatus: false,
        inputType: InputType.TEXTBOX,
    },
    [ParameterType.AREA_ID]: {
        parameterType: ParameterType.AREA_ID,
        label: TranslationKeyMap._148_AREA,
        hasStatus: true,
        inputType: InputType.DROPDOWN,
        placeholder: TranslationKeyMap._976_SELECT_AN_AREA,
    },
    [ParameterType.REGION_ID]: {
        parameterType: ParameterType.REGION_ID,
        label: TranslationKeyMap._149_REGION,
        hasStatus: true,
        inputType: InputType.DROPDOWN,
        placeholder: TranslationKeyMap._974_SELECT_A_REGION,
    },
    [ParameterType.LOB_ID]: {
        parameterType: ParameterType.LOB_ID,
        label: TranslationKeyMap._583_LOB,
        hasStatus: true,
        inputType: InputType.DROPDOWN,
        placeholder: TranslationKeyMap._583_LOB,
    },
};

export function userSearchResultFromUserTransformer(
    model: User,
): UserSearchResult {
    return {
        userId: model.id,
        userName: `${model.firstName} ${model.lastName}`.trim(),
        siteId: null,
        site: null,
        roleId: null,
        role: null,
        managerId: null,
        managerName: null,
        superGroupId: null,
        superGroup: null,
        systemId: null,
        favourite: null,
        active: null,
    };
}

export function userSearchResultFromUserHierarchyTransformer(
    model: UserHierarchy,
): UserSearchResult {
    return {
        userId: model.userId,
        userName: model.managerName, // yes, managerName. see UserHierarchyModelTransformer
        siteId: null,
        site: null,
        roleId: null,
        role: null,
        managerId: null,
        managerName: null,
        superGroupId: null,
        superGroup: null,
        systemId: null,
        favourite: null,
        active: null,
    };
}

export function userSearchResultFromPersonOfInterestModelTransformer(
    model: PersonOfInterestModel,
): UserSearchResult {
    return {
        userId: model.userId,
        userName: `${model.firstName} ${model.lastName}`.trim(),
        siteId: null,
        site: null,
        roleId: null,
        role: null,
        managerId: null,
        managerName: null,
        superGroupId: null,
        superGroup: null,
        systemId: null,
        favourite: model.isAvailable,
        active: null,
    };
}

export enum ColumnID {
    NAME,
    SITE,
    ROLE,
    SUPER_GROUP,
    MANGER_NAME,
    STATUS,
}

export function compare(
    cellA: CellNode,
    cellB: CellNode,
    rowA: RowNode,
    rowB: RowNode,
    def: Sort,
): number {
    try {
        const columnId = parseInt(def.columnId);
        const ctxA: UserSearchResult = cellA.context.ctx;
        const ctxB: UserSearchResult = cellB.context.ctx;
        let valA: any;
        let valB: any;
        switch (columnId) {
            case ColumnID.NAME:
                valA = ctxA.userName;
                valB = ctxB.userName;
                break;
            case ColumnID.SITE:
                valA = ctxA.site;
                valB = ctxB.site;
                break;
            case ColumnID.ROLE:
                valA = ctxA.role;
                valB = ctxB.role;
                break;
            case ColumnID.SUPER_GROUP:
                valA = ctxA.superGroup;
                valB = ctxB.superGroup;
                break;
            case ColumnID.MANGER_NAME:
                valA = ctxA.managerName;
                valB = ctxB.managerName;
                break;
            case ColumnID.STATUS:
                valA = ctxA.active ? 'a' : 'b';
                valB = ctxB.active ? 'a' : 'b';
                break;
            default:
                console.error('invalid column');
                return Number.MIN_SAFE_INTEGER;
        }
        valA = valA == null ? '' : valA;
        valB = valB == null ? '' : valB;
        return def.order === SortOrder.ASC
            ? valA.localeCompare(valB)
            : valB.localeCompare(valA);
    } catch (e) {
        console.log(e);
        return Number.MIN_SAFE_INTEGER;
    }
}
